// extracted by mini-css-extract-plugin
module.exports = {"container":"ClientInfo_container__3NDce"};